module.exports = __webpack_public_path__ + "img/legende400.9942318a.jpg";